import { Component, OnInit } from '@angular/core';
import { DashboardFilters } from './dashboard-filters.model';
import { PayGroup } from '../../../shared/models/pay-group.model';
import { PayGroupService } from '../../../services/paygroup.service';
import { PayrollTypeInfo, PayrollCycleType } from '../../../services/payroll-types.service';
import { PayrollTypeService } from '../../../services/payroll-types.service';
import * as moment from 'moment';
import { map, takeUntil } from 'rxjs/operators';
import { FiltersService } from './filters.service';
import { sortBy, max } from 'lodash';
import { BaseObserver } from '../../../shared/baseobserver';
import { PayrollScheduleService } from '../../../services/payroll-schedule.service';
import { PayrollSchedule } from '../../../services/payroll-schedule.model';
import { DatePickerConfiguration } from '../../../shared/components/date-picker/date-picker.model';
import { FeatureToggleService } from '../../../shared/services/feature-toggle/feature-toggle.service';
import { Moment } from 'moment';

@Component({
  selector: 'ssg-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.less']
})
export class FiltersComponent extends BaseObserver implements OnInit {
  defaultDate = moment({ year: 1, month: 0, day: 1 });
  minDate = moment({ year: 2018, month: 8, day: 1 });
  filters: DashboardFilters;

  editFilters: DashboardFilters;
  allPayGroups: PayGroup[] = [];
  allPayrollTypes: PayrollTypeInfo[] = [];
  private _payrollSchedule: PayrollSchedule;
  payrollScheduleDates: DatePickerConfiguration;
  allProducts = ['AT_A_GLANCE.PRODUCT_EMPLOYEE_PAY'];

  isEditing = false;
  isInvalid = false;

  get selectedPayGroups() {
    if (this.filters && this.filters.payGroups && this.filters.payGroups.length) {
      return this.filters.payGroups;
    }

    return this.allPayGroups;
  }

  get payrollSchedule(): PayrollSchedule {
    return this._payrollSchedule;
  }

  set payrollSchedule(schedule: PayrollSchedule) {
    if (schedule) {
      this._payrollSchedule = new PayrollSchedule(schedule);
      this.payrollScheduleDates = new DatePickerConfiguration({
        minDate: moment(schedule.minDateUtc),
        maxDate: moment(schedule.maxDateUtc),
        whitelist: schedule.schedule.map(p => moment.utc(p.utcDate)),
        allowPriorToMinDate: true,
        allowAfterMaxDate: true,
        enforceManualEntry: false,
        disabledMessage: 'COMMON.INVALID_PAY_DATE'
      });
    } else {
      this._payrollSchedule = null;
      this.payrollScheduleDates = null;
    }
  }

  constructor(private _payGroupService: PayGroupService,
              private _payrollTypeService: PayrollTypeService,
              private _payrollScheduleService: PayrollScheduleService,
              private _featureToggleService: FeatureToggleService,
              private _filtersService: FiltersService) {
    super();
  }

  ngOnInit() {
    this.getAllPayGroups();
    this.initPayrollTypes();
    this.initFilters();
  }

  startEditing() {
    this.editFilters = Object.assign(new DashboardFilters(null, null, null), this.filters);
    this.isEditing = true;
  }

  applyEdits() {
    this.filters = this.editFilters;
    this.isEditing = false;
    this._filtersService.updateFilters(this.filters);
  }

  cancelEdits() {
    this.isEditing = false;
  }

  clearEditFilters() {
    this.editFilters = this.createDefaultFilter();
  }

  getCode(payGroup: PayGroup) {
    return payGroup.code.trim();
  }

  initPayrollTypes() {
    this._payrollTypeService.getPayrollTypes()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => this.allPayrollTypes = result);
  }

  payrollTypeCompareWith(currentValue, compareValue): boolean {
    return currentValue.toString() === compareValue.toString();
  }

  initFilters() {
    this._filtersService.getFilters().subscribe(filters => {
      this.filters = filters;
      if (this.isEditing) {
        this.startEditing();
      }
    });
    if (this._featureToggleService.isFeatureEnabled('enableDefaultPayDate')) {
      this.initPayrollSchedule();
    } else {
      this.filters.payDate = moment.utc().startOf('day').add('5', 'hours');
    }
  }

  initPayrollSchedule() {
    this._payrollScheduleService.getPayrollSchedule()
    .subscribe(result => {
      this.payrollSchedule = result;
    });
  }

  createDefaultFilter(): DashboardFilters {
    return new DashboardFilters(this._defaultPayrollDate(), PayrollCycleType.All, []);
  }

  getAllPayGroups(): void {
    this._payGroupService.getPayGroups()
      .pipe(
        map(groups => sortBy(groups, ['code', 'name'])),
        takeUntil(this.destroy$)
      )
      .subscribe(result => this.allPayGroups = result);
  }

  getPayrollTypeName(): string {
    if (!this.allPayrollTypes || this.allPayrollTypes.length < 1) {
 return '';
}
    return this.allPayrollTypes.find(t => t.value === this.filters.payrollType).localizedName;
  }

  private _defaultPayrollDate(): Moment {
    return max([this.minDate, this.payrollSchedule ? this.payrollSchedule.getDefaultPayrollDate() : moment().utc()]);
  }

  UpdateFilter(event: any) {
    this.editFilters.payrollType = Number(event.detail.value);
  }

   filterSelection(item): boolean {
    return this.editFilters.payGroups.findIndex(x => x.code === item.code) > -1;
   }
}
